var ModeModel = function (pageModelHndl) {
    var that = this;

    that.IsSelected = ko.observable(false);
    that.ModeId = ko.observable();
    that.DisplayText = ko.observable();
    that.IsEnabled = ko.observable(true);

    //subscriptions
    that.IsSelected.subscribe(function (boolStatus) {
        if (boolStatus) {
            $.post(ajaxUrls.order.ProductConfigurationModeChanged, { selectedMode: that.ModeId() }).fail(function () {
                alerts.error();
            });
        }
    });
};